/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_Multiple_TextInputs */

const en_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to merge the selected events?`)
};

const fr_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir fusionner les evenements selectionnes ?`)
};

const de_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie die ausgewählten Ereignisse wirklich zusammenführen?`)
};

const it_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi davvero unire gli eventi selezionati?`)
};

const ru_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите объединить выбранные события?`)
};

const es_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea fusionar los eventos seleccionados?`)
};

const zh_cn2_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要合并所选事件吗？`)
};

const ja_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを結合してもよろしいですか?`)
};

const hi_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई चयनित इवेंट्स को मर्ज करना चाहते हैं?`)
};

const pt_pt2_merge_swal_multiple_text = /** @type {(inputs: Merge_Swal_Multiple_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja mesclar os eventos selecionados?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to merge the selected events?" |
*
* @param {Merge_Swal_Multiple_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_multiple_text = /** @type {((inputs?: Merge_Swal_Multiple_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_Multiple_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_multiple_text(inputs)
	if (locale === "de") return de_merge_swal_multiple_text(inputs)
	if (locale === "it") return it_merge_swal_multiple_text(inputs)
	if (locale === "ru") return ru_merge_swal_multiple_text(inputs)
	if (locale === "es") return es_merge_swal_multiple_text(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_multiple_text(inputs)
	if (locale === "ja") return ja_merge_swal_multiple_text(inputs)
	if (locale === "hi") return hi_merge_swal_multiple_text(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_multiple_text(inputs)
	return en_merge_swal_multiple_text(inputs)
});